// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import 'react-datepicker/dist/react-datepicker.css';

import React from 'react';
import MainLayout from '../../layouts/MainLayout';
import UserDataCard from './UserDataCard';
import InterestDataCard from './InterestDataCard';
import ResetPassword from './ResetPassword'
import S from './styles';
import { getQueryParams, useQuery } from '../../lib/utility';

const MemberPage = (): JSX.Element => {
  const { changePassword } = getQueryParams(useQuery());
  return (
    <MainLayout>
      <S.Body>
        <UserDataCard />
        <InterestDataCard />
        {changePassword && <ResetPassword />}
      </S.Body>
    </MainLayout>
  )
};

export { MemberPage as default };
